export default "__VITE_ASSET__D_hvYmZz__"